import axios from 'axios';
import instance from './base';

export async function createArchives(start, end, branchID) {
  const data = {
    start_from: start,
    end_at: end,
  };
  if (branchID) {
    data.branch_id = branchID;
  }
  await instance.post('/v1/user_records/archives', data);
}

export async function getArchives() {
  const rsp = await instance.get('/v1/user_records/archives', {

  });
  return rsp.data;
}

const downloadInstance = axios.create({
  baseURL: '/api',
  withCredentials: true,
  timeout: 15 * 60 * 1000, // 15 minutes
  headers: {
    'Content-Type': 'application/json',
  },
});
export async function getMonthAppointments(startAt, endAt) {
  const rsp = await downloadInstance.get(`/v1/appointments/export?start_at=${startAt}&end_at=${endAt}`);
  return rsp.data;
}
export async function getMonthActivities(startAt, endAt) {
  const rsp = await downloadInstance.get(`/v1/activities/export?start_at=${startAt}&end_at=${endAt}`);
  return rsp.data;
}
export async function startArchiveMonthReceipts(startAt, endAt) {
  const rsp = await downloadInstance.post(`/v1/export_receipts?start_time=${startAt}&end_time=${endAt}`);
  return rsp.data;
}
export async function getMonthReceiptsStatus(startAt, endAt) {
  const rsp = await downloadInstance.get(`/v1/export_receipts_status?start_time=${startAt}&end_time=${endAt}`);
  return rsp.data;
}
export function downloadMonthReceiptsURL(startAt, endAt) {
  return `/api/v1/export_receipts?start_time=${startAt}&end_time=${endAt}`;
}
